import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_85319587-e4ee-4a62-aecb-a60ff1e5f34f/artifacts/rjbabvt5_image.png"
                alt="Kiwi Connect Consultants Logo"
                className="h-20 object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Your trusted partner for global visas & immigration. Specialized in New Zealand visas with expertise across UK, Europe, and beyond.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-teal-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-sm hover:text-teal-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-sm hover:text-teal-400 transition-colors">Visa Services</Link></li>
              <li><Link to="/new-zealand-visas" className="text-sm hover:text-teal-400 transition-colors">New Zealand Visas</Link></li>
              <li><Link to="/eligibility" className="text-sm hover:text-teal-400 transition-colors">Eligibility Check</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-teal-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-teal-400 transition-colors">🇳🇿 New Zealand Visas</li>
              <li className="hover:text-teal-400 transition-colors">🇬🇧 UK Skilled Worker Visa</li>
              <li className="hover:text-teal-400 transition-colors">🇬🇧 UK Youth Mobility Visa</li>
              <li className="hover:text-teal-400 transition-colors">🇪🇺 Schengen Tourist Visa</li>
              <li className="hover:text-teal-400 transition-colors">🎓 Student Visas</li>
              <li className="hover:text-teal-400 transition-colors">🌍 Work Visas & PR</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <a href={`mailto:${contactInfo.email}`} className="flex items-start gap-2 text-sm hover:text-teal-400 transition-colors group">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0 group-hover:text-teal-400" />
                <span className="break-all">{contactInfo.email}</span>
              </a>
              
              {/* Instagram directly under email */}
              <a 
                href={`https://instagram.com/${contactInfo.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-pink-400 transition-colors group"
              >
                <Instagram className="h-4 w-4 group-hover:text-pink-400" />
                <span>@{contactInfo.instagram}</span>
              </a>
              
              <a href={`tel:${contactInfo.phones.india1}`} className="flex items-center gap-2 text-sm hover:text-teal-400 transition-colors">
                <Phone className="h-4 w-4 flex-shrink-0" />
                {contactInfo.phones.india1}
              </a>
              <a href={`tel:${contactInfo.phones.india2}`} className="flex items-center gap-2 text-sm hover:text-teal-400 transition-colors">
                <Phone className="h-4 w-4 flex-shrink-0" />
                {contactInfo.phones.india2}
              </a>
              <a href={`tel:${contactInfo.phones.newZealand}`} className="flex items-center gap-2 text-sm hover:text-teal-400 transition-colors">
                <Phone className="h-4 w-4 flex-shrink-0" />
                {contactInfo.phones.newZealand}
              </a>
              <div className="space-y-2">
                <div className="flex items-start gap-2 text-sm">
                  <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="font-semibold text-white">Head Office:</p>
                    <p>{contactInfo.addresses.headOffice}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>© 2024 Kiwi Connect Consultants. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-teal-400 transition-colors">Privacy Policy</Link>
              <Link to="/disclaimer" className="hover:text-teal-400 transition-colors">Disclaimer</Link>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-4 text-center">
            Disclaimer: Kiwi Connect Consultants is an independent immigration consultancy. We do not guarantee visa approvals. All decisions are made solely by the respective immigration authorities.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
